import React from "react";
import {
  PauseIcon,
  Trash,
  ExportResult,
  RestartTIconToolbar,
} from "../../assets/icon";



const ManageCampaignToolbar = ({
  isHold,
  isArchived,
  statusKey,
  statusLoading,
  onRestart,
  onHold,
  onArchive,
  onExport,
  viewOnly = false,
}) => {
  const showRestart =
    !viewOnly && statusKey === "hold" && !isArchived;
  const showHold =
    !viewOnly && statusKey === "active" && !isArchived && !isHold;
  const showArchive =
    !viewOnly &&
    (statusKey === "active" || statusKey === "hold" || statusKey === "draft") &&
    !isArchived;
  // const showExport = !isArchived;

  return (
    <div className="d-flex gap-3">
      {showRestart && (
        <div
          className="btn d-flex align-items-center gap-2 custom-button fs-16"
          onClick={onRestart}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              onRestart();
            }
          }}
        >
          <RestartTIconToolbar />
          Restart
        </div>
      )}
      {showHold && (
        <div
          className="btn d-flex align-items-center gap-2 custom-button fs-16"
          onClick={onHold}
          disabled={statusLoading}
        >
          <PauseIcon />
          Hold
        </div>
      )}
      {showArchive && (
        <div
          className="btn d-flex align-items-center gap-2 custom-button fs-16"
          onClick={onArchive}
          disabled={statusLoading}
        >
          <Trash color={"#162C4E"} />
          Archive
        </div>
      )}
      {/* {showExport && ( */}
      <div
        className="btn d-flex align-items-center gap-2 custom-button fs-16"
        onClick={onExport}
      >
        <ExportResult color={"#162C4E"} />
        Export Result
      </div>
      {/* )} */}
    </div>
  );
};

export default ManageCampaignToolbar;
